import lightGallery from 'npm:lightgallery'
import lgThumbnail from 'npm:lightgallery/plugins/thumbnail'
import lgZoom from 'npm:lightgallery/plugins/zoom'

import Cookies from 'npm:js-cookie'

(function () {
  const e = document.getElementById('lightgallery')
  if (!e) return
  lightGallery(e, {
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    download: false,
    licenseKey: '5CD286E1-D8654D60-9B001C45-E3134703'
  })
})();
